'use client'

import { motion } from 'framer-motion'
import { Quote } from 'lucide-react'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'
import { Card, CardContent } from '@/components/ui/card'
import { StarRating } from '@/components/ui/star-rating'
import { testimonials } from '@/content/data/testimonials'

interface TestimonialsProps {
  background?: 'white' | 'gray'
}

export function Testimonials({ background = 'white' }: TestimonialsProps) {
  return (
    <Section background={background}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-display-1 text-stone-900 mb-4">
            Loved by Merchants Worldwide
          </h2>
          <p className="text-body-lg max-w-2xl mx-auto">
            See what our partners are saying about Buddify.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((testimonial, index) => (
            <motion.div
              key={testimonial.author}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full">
                <CardContent className="pt-6">
                  <Quote className="w-8 h-8 text-primary-200 mb-4" />

                  <StarRating rating={testimonial.rating} className="mb-4" />

                  <p className="text-stone-600 mb-6 leading-relaxed">
                    &ldquo;{testimonial.quote}&rdquo;
                  </p>

                  <div>
                    <p className="font-semibold text-stone-900">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-stone-500">
                      {testimonial.role}, {testimonial.company}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
